import { Key, useMemo } from 'react'
import { WorkflowPermissionRecord } from '../../types'

/** Excludes deleted permissions even when their table keys remain selected. */
export function useSelectedPermissions(
  permissions: WorkflowPermissionRecord[],
  selectedRowKeys: Key[]
) {
  return useMemo(() => {
    const selected = new Set(selectedRowKeys.map((key) => key.toString()))
    return permissions.filter(({ deleted, id }) => !deleted && selected.has(id))
  }, [permissions, selectedRowKeys])
}
